import { type Credentials, type SessionState } from './types';

export const initialStateSession: SessionState = {
  status: 'unknown',
  hasError: false,
  isLoading: false,
  credentials: {
    accessToken: '',
    idToken: '',
  },
};

export const emptyCredential: Credentials = {
  accessToken: '',
  idToken: '',
};

export const emptyState: SessionState = {
  status: 'notLogged',
  hasError: false,
  isLoading: false,
  credentials: emptyCredential,
};
